import React from "react";

export default function OverView({ data }) {
  return (
    <div className="template-overview-container">
      <div className="content">
        <div className="steps">
          <h3>{data?.heading}</h3>
        </div>
        {data?.items?.map((el, index) => {
          return (
            <div className="steps">
              <p>
                {index + 1}. {el}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
